import React from 'react'

import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'

import { DocumentImageList } from './components/DocumentImageList'

export const DocumentImageListPage = () => {
  useLogEventOnMount('Access to saved table and graph')

  return <DocumentImageList />
}
